import './ContentSpinner.css'

import { IonInfiniteScroll, IonInfiniteScrollContent } from "@ionic/react";

interface Props {
    loadData: any
}

const ContentSpinner: React.FC<Props> = (props) => {
    return <>
        {props.children}
        <IonInfiniteScroll className="content-spinner" threshold="50px" onIonInfinite={props.loadData}>
            <IonInfiniteScrollContent loadingSpinner="crescent">
            </IonInfiniteScrollContent>
        </IonInfiniteScroll>
    </>
}

export default ContentSpinner;